import React, { useEffect, useState } from "react";
import {
  createSearch,
  deleteSearch,
  deleteServices,
  editServices,
  getSearch,
  getServices,
  updateSearch,
} from "../../services/Admin/adminServices";
import Dropdown from "react-bootstrap/Dropdown";
import { Button, Modal, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import EditServiceModal from "./ServicePosting";
import { useNavigate } from "react-router-dom";
import Pagination from "../components/Pagination";
import Spinner from "../components/Common/Spinner";
import LocationSearchDropdown from "../components/LocationDropDown";
import { debounce } from "lodash";
import LocationAdd from "../components/LocationAdd";
import ServiceSearchDropdown from "../components/ServiceSearchDropdown";


const SearchCompoment = () => {
  const [service, setService] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  
  // Delete Confirmation Modal State
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const navigate = useNavigate()
  const getservices = async () => {
    try {
      setLoading(true);

      const response = await getSearch(currentPage, 10, debouncedSearch);
      setService(response?.data?.data?.searches);
      setTotalItems(response?.data?.data.pagination.total);
    } catch (error) {
      console.error("errors", error);
    }
    finally {
      setLoading(false);
    }
  };

  const handleView = (serviceItem) => {
    setSelectedService(serviceItem);
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
    setSelectedService(null);
  };

  const handleDeleteClick = (serviceItem) => {
    setItemToDelete(serviceItem);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!itemToDelete) return;
    try {
      setDeleting(true);
      await deleteSearch(itemToDelete._id);
      setService((prev) => prev.filter((s) => s._id !== itemToDelete._id));
      setTotalItems((prev) => prev - 1);
      toast.success("Deleted successfully");
      setShowDeleteModal(false);
      setItemToDelete(null);
    } catch (error) {
      console.error("error-> ", error);
      toast.error("Failed to delete item");
    } finally {
      setDeleting(false);
    }
  };


  useEffect(() => {
    const handler = debounce(() => {
      setDebouncedSearch(search);
    }, 500);

    handler();

    return () => {
      handler.cancel();
    };
  }, [search]);


  useEffect(() => {
    getservices();
  }, [currentPage, debouncedSearch]);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );
  const totalPages = Math.ceil(totalItems / itemsPerPage);


  // inside SearchCompoment.jsx

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    phone: Yup.string().required("Phone is required"),
    email: Yup.string().email("Invalid email").matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Email must be a valid format"
    ).required("Email is required"),
    address: Yup.object().shape({
      street: Yup.string().required("Street is required"),
      city: Yup.string().required("City is required"),
      state: Yup.string().required("State is required"),
      zip: Yup.string().required("Zip is required"),
      country: Yup.string().required("Country is required"),
      location: Yup.object().shape({
        coordinates: Yup.array()
          .of(Yup.number())
          .min(2, "Longitude and Latitude required"),
      }),
    }),
  });



  const initialFormValues = {
    title: "",
    phone: "",
    email: "",
    services: [],
    address: {
      street: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      location: {
        type: "Point",
        coordinates: [0, 0]
      },

    },
  };


  return (
    <div  >


      <h1 style={{ color: "#0AB7EA" }}>Search</h1>








      <div className="pb-2 d-flex flex-wrap justify-content-between gap-2 align-items-center mb-4">
        <div className="flex-grow-1">
          <input
            type="text"
            style={{ borderRadius: "0.5rem", borderColor: "#0AB7EA" }}
            className="form-control w-100"
            placeholder="Search....."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div>
          <button

            className="btn"
            style={{
              backgroundColor: "#0AB7EA",
              color: "white",       // text color
              border: "none",       // remove border
              padding: "8px 16px",  // optional padding
              borderRadius: "4px",
              marginBottom: "4px" // optional rounded corners
            }}
            onClick={() => setShowModal(true)}
          >
            Add new
          </button></div>
      </div>








      {loading ? (

        <Spinner />
      ) : service.length === 0 ? (
        <p>No search   available.</p>
      ) : (<div className="row">
        {service.map((serviceItem, index) => (
          <div className="col-md-6 mb-4" key={serviceItem._id || index}>
            <div
              className={`card shadow-lg card-custom  position-relative`}
            >
              <div className="card-body d-flex justify-content-between align-items-start">
                <div>
                  <h5 className="card-title">{serviceItem.title}</h5>
                  <p className="card-text mb-1" style={{ color: "gray" }}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.75 12.315V14.9671C15.75 15.3608 15.4456 15.6875 15.0529 15.7153C14.7248 15.7384 14.4572 15.75 14.25 15.75C7.62255 15.75 2.25 10.3774 2.25 3.75C2.25 3.54278 2.26159 3.27515 2.28476 2.94713C2.31253 2.55441 2.6392 2.25 3.03289 2.25H5.68508C5.87758 2.25 6.03882 2.39582 6.05815 2.58735C6.0755 2.7593 6.09163 2.89735 6.10655 3.00151C6.25826 4.06104 6.56815 5.06952 7.01152 6.00227C7.08269 6.15199 7.03628 6.33119 6.90139 6.42754L5.28266 7.58385C6.26814 9.88583 8.11417 11.7319 10.4162 12.7174L11.5703 11.1014C11.6679 10.9649 11.8492 10.918 12.0007 10.9899C12.9334 11.4329 13.9418 11.7425 15.0012 11.8938C15.1047 11.9087 15.2419 11.9246 15.4126 11.9419C15.6042 11.9612 15.75 12.1225 15.75 12.315Z" fill="#111111" />
                    </svg>  {serviceItem.phone}
                  </p>
                  <p className="card-text mb-2" style={{ color: "gray" }}> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.25 2.25H15.75C16.1642 2.25 16.5 2.58579 16.5 3V15C16.5 15.4142 16.1642 15.75 15.75 15.75H2.25C1.83579 15.75 1.5 15.4142 1.5 15V3C1.5 2.58579 1.83579 2.25 2.25 2.25ZM9.04545 8.76218L4.23541 4.67828L3.26458 5.82172L9.05482 10.7378L14.7408 5.81712L13.7592 4.68288L9.04545 8.76218Z" fill="#111111" />
                  </svg>
                    &nbsp;
                    {serviceItem.email}</p>

                  {(() => {
                    const servList = Array.isArray(serviceItem.services)
                      ? serviceItem.services
                      : Array.isArray(serviceItem.service)
                      ? serviceItem.service
                      : serviceItem.services
                      ? [serviceItem.services]
                      : serviceItem.service
                      ? [serviceItem.service]
                      : [];

                    if (servList.length === 0) return null;

                    return (
                      <div className="mt-2">
                        <small className="text-muted d-block mb-1" style={{ fontSize: "12px", fontWeight: "600" }}>
                          Services:
                        </small>
                        <div className="d-flex flex-wrap gap-1">
                          {servList.map((s, sIdx) => {
                            const title = typeof s === "object" && s?.title ? s.title : s;
                            return (
                              <span
                                key={s._id || sIdx}
                                className="badge"
                                style={{ backgroundColor: "#0AB7EA", color: "#fff", fontSize: "11px", fontWeight: "normal" }}
                              >
                                {title}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })()}
                </div>
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    id={`dropdown-basic-${index}`}
                    style={{ padding: "4px 8px" }}
                  >
                    {svg1}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleView(serviceItem)}>
                      Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handleDeleteClick(serviceItem)}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        ))}
      </div>)}









      <div className="card-footer clearfix">
        <div className="d-flex justify-content-between align-items-center">
          <div
            className="dataTables_info"
            style={{ color: "#0AB7EA" }}
          >
            Showing {currentPage * itemsPerPage + 1} to{" "}
            {totalItems > (currentPage + 1) * itemsPerPage
              ? (currentPage + 1) * itemsPerPage
              : totalItems}{" "}
            of {totalItems} entries
          </div>
          <div
            className="d-flex align-items-center"
            style={{ gap: "10px" }}
          >
            <Pagination
              pageCount={totalPages}
              pageValue={currentPage}
              setPage={setCurrentPage}
            />
          </div>
        </div>
      </div>



      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#0AB7EA" }}>
            {selectedService ? "Edit Search" : "Add New Search"}
          </Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={selectedService || initialFormValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={async (values, { setSubmitting }) => {
            try {
              const formattedServices = Array.isArray(values.services)
                ? values.services.map((s) => (typeof s === "object" ? s._id : s)).filter(Boolean)
                : values.services
                ? [typeof values.services === "object" ? values.services._id : values.services].filter(Boolean)
                : [];

              if (selectedService) {
                const payload = {
                  id: values._id,
                  title: values.title,
                  phone: values.phone,
                  email: values.email,
                  address: {
                    street: values.address.street,
                    city: values.address.city,
                    state: values.address.state,
                    zip: values.address.zip,
                    country: values.address.country,
                    location: {
                      type: values.address.location.type,
                      coordinates: values.address.location.coordinates,
                    },
                  },
                };

                if (formattedServices.length > 0) {
                  payload.services = formattedServices;
                }

                // 🔄 Update
                await updateSearch(payload);
                toast.success("Updated successfully");
              } else {
                // ➕ Add
                const payload = { ...values };
                if (formattedServices.length > 0) {
                  payload.services = formattedServices;
                } else {
                  delete payload.services;
                }

                await createSearch(payload);
                toast.success("Added successfully");
              }
              handleClose();
              getservices();
            } catch (error) {
              toast.error("Something went wrong");
              console.error(error);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting, setFieldValue, value }) => (
            <FormikForm>
              <Modal.Body>
                {/* Title */}
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Field
                    name="title"
                    className="form-control"
                    style={{ borderColor: "#0AB7EA" }}
                  />
                  <ErrorMessage name="title" component="div" className="text-danger" />
                </Form.Group>

                {/* Phone */}
                <Form.Group className="mb-3">
                  <Form.Label>Phone</Form.Label>
                  <Field
                    name="phone"
                    className="form-control"
                    style={{ borderColor: "#0AB7EA" }}
                  />
                  <ErrorMessage name="phone" component="div" className="text-danger" />
                </Form.Group>

                {/* Email */}
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Field
                    name="email"
                    type="email"
                    className="form-control"
                    style={{ borderColor: "#0AB7EA" }}
                  />
                  <ErrorMessage name="email" component="div" className="text-danger" />
                </Form.Group>

                {/* Services */}
                <Form.Group className="mb-3">
                  <Form.Label>Services</Form.Label>
                  <Field name="services">
                    {({ field, form }) => (
                      <ServiceSearchDropdown
                        value={field.value || selectedService?.services || selectedService?.service || []}
                        onSelect={(selectedServicesList) => {
                          form.setFieldValue(
                            "services",
                            selectedServicesList.map((s) => s._id)
                          );
                        }}
                      />
                    )}
                  </Field>
                  <ErrorMessage name="services" component="div" className="text-danger" />
                </Form.Group>

                {/* Address */}
                <h5 style={{ color: "#0AB7EA" }}>Address</h5>


                <div className="mb-2">
                  <label className="form-label">street  </label>
                  <Field name="address.street">
                    {({ form, field }) => (

                      selectedService ? (<LocationSearchDropdown
                        value={field.value}
                        onSelect={(location) => {


                          form.setFieldValue("address.city", location.city || "");
                          form.setFieldValue("address.state", location.state || "");
                          form.setFieldValue("address.street", location.name || "");
                          form.setFieldValue("address.zip", location.pincode || "");
                          form.setFieldValue("address.country", location.country || "");
                          form.setFieldValue("address.location.type", location.location?.type || "");
                          form.setFieldValue("address.location.coordinates[0]", location.location?.coordinates?.[0] || "");
                          form.setFieldValue("address.location.coordinates[1]", location.location?.coordinates?.[1] || "");
                        }}
                      />) : (

                        <LocationAdd

                          onSelect={(location) => {


                            form.setFieldValue("address.city", location.city || "");
                            form.setFieldValue("address.state", location.state || "");
                            form.setFieldValue("address.street", location.name || "");
                            form.setFieldValue("address.zip", location.pincode || "");
                            form.setFieldValue("address.country", location.country || "");
                            form.setFieldValue("address.location.type", location.location?.type || "");
                            form.setFieldValue("address.location.coordinates[0]", location.location?.coordinates?.[0] || "");
                            form.setFieldValue("address.location.coordinates[1]", location.location?.coordinates?.[1] || "");
                          }}
                        />

                      )



                    )}
                  </Field>
                </div>




                {["city", "state", "zip", "country"].map((field) => (
                  <Form.Group className="mb-3" key={field}>
                    <Form.Label>{field}</Form.Label>
                    <Field
                      name={`address.${field}`}
                      className="form-control"
                      style={{ borderColor: "#0AB7EA" }}
                    />
                    <ErrorMessage
                      name={`address.${field}`}
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                ))}


              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={isSubmitting}>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  style={{ backgroundColor: "#0AB7EA", border: "none" }}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {selectedService ? "Updating..." : "Adding..."}
                    </>
                  ) : (
                    selectedService ? "Update" : "Add"
                  )}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered size="md">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="text-danger fw-bold fs-5">
            <i className="fa fa-exclamation-triangle me-2"></i> Confirm Delete
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3">
          <p className="mb-0 text-secondary">
            Are you sure you want to delete <strong>"{itemToDelete?.title || "this item"}"</strong>? This action cannot be undone.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)} disabled={deleting}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete} disabled={deleting}>
            {deleting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SearchCompoment;
